// App.js
import * as React from "react";
import { Admin, CustomRoutes, defaultTheme, Layout, Resource, withLifecycleCallbacks } from "react-admin";
import simpleRestProvider from 'ra-data-simple-rest';
import { Route } from "react-router-dom";
import { ClinicEdit, ClinicList } from "./resources/clinics";
import { DoctorList, DoctorEdit, DoctorCreate } from "./resources/doctors";
import { AppointmentEdit, AppointmentList } from "./resources/appointments";
import LoginPage from "./auth/LoginPage";
import authProvider from "./auth/authProvider";
import { ScheduleList, ScheduleEdit, ScheduleCreate } from "./resources/schedules";
import { CustomMenu } from "./components/customMenu";
import { PublicAppointmentShow } from "./resources/public";
import { apiEndpoint as dataProviderEndpoint, httpClient } from "./httpClient";


const handleErrors = (error) => {
  if (error?.body?.detail) {
    error.message = error.body.detail;
  }
  return Promise.reject(error)
};


// Создаем базовый dataProvider
const baseDataProvider = simpleRestProvider(dataProviderEndpoint, httpClient);

// Обработка ошибок
const dataProviderWithErrorHandling = {
  ...baseDataProvider,
  create: async (resource, params) => {
    try {
      return await baseDataProvider.create(resource, params);
    } catch (error) {
      return handleErrors(error);
    }
  },
  update: async (resource, params) => {
    try {
      return await baseDataProvider.update(resource, params);
    } catch (error) {
      return handleErrors(error);
    }
  },
  getOne: async (resource, params) => {
    try {
      return await baseDataProvider.getOne(resource, params);
    } catch (error) {
      return handleErrors(error);
    }
  },
  getList: async (resource, params) => {
    try {
      return await baseDataProvider.getList(resource, params);
    } catch (error) {
      return handleErrors(error);
    }
  },
};

// Обертка для преобразования _id в id
const customDataProvider = withLifecycleCallbacks(dataProviderWithErrorHandling, [
  {
    resource: '*',
    // beforeGetList: async (params, dataProvider) => {
    //   // Преобразуем сортировку перед запросом
    //   if (params.sort) {
    //     return {
    //       ...params,
    //       sort: JSON.stringify([params.sort.field, params.sort.order])
    //     };
    //   }
    //   return params;
    // },
    afterGetList: async (result, dataProvider) => ({
      ...result,
      data: result.data.map(item => ({
        ...item,
        id: item._id || item.id
      }))
    }),
    afterGetOne: async (result) => ({
      ...result,
      data: {
        ...result.data,
        id: result.data._id || result.data.id
      }
    }),
    afterGetMany: async (result) => ({
      ...result,
      data: result.data.map(item => ({
        ...item,
        id: item._id || item.id
      }))
    }),
    afterCreate: async (result) => ({
      ...result,
      data: {
        ...result.data,
        id: result.data._id || result.data.id
      }
    }),
    afterUpdate: async (result) => ({
      ...result,
      data: {
        ...result.data,
        id: result.data._id || result.data.id
      }
    }),
  }
]);

const myTheme = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: {
      main: "#2A765A",
    },
    secondary: {
      main: "#2A765A",
    },
  },
  typography: {
    fontFamily: [
      'Roboto', 
      '"Helvetica Neue"', 
      'Arial', 
      'sans-serif',
    ].join()
  }
}

const myLayout = ({ children }) => (
    <Layout menu={CustomMenu}>
        {children}
    </Layout>
);

export const App = () => (
  <Admin 
    dataProvider={customDataProvider}
    authProvider={authProvider}
    theme={myTheme}
    loginPage={LoginPage}
    layout={myLayout}
  >
    <Resource name="clinics" 
      list={ClinicList}
      edit={ClinicEdit}
      options={{
        label: "Клиника",
      }}
    >
    </Resource>
    <Resource name="doctors"
      list={DoctorList}
      edit={DoctorEdit}
      create={DoctorCreate}
      options={{
        label: "Врачи"
      }}
    >
    </Resource>
    <Resource name="appointments"
      list={AppointmentList}
      edit={AppointmentEdit}
      options={{
        label: "Записи на прием",
      }}
    >
    </Resource>
    <Resource name="schedules"
      list={ScheduleList}
      edit={ScheduleEdit}
      create={ScheduleCreate}
      options={{
        label: "Расписания",
      }}
    >
    </Resource>
    {/* Публичный ресурс для пациентов */}
    {/* <Resource 
      name="public/appointments/:id"
      list={PublicAppointmentShow}
      options={{ label: "Запись к врачу" }}
      disableAuthentication={true}
    /> */}
    <CustomRoutes noLayout>
      <Route path="/public/appointments/:id" element={<PublicAppointmentShow />} />
    </CustomRoutes>
  </Admin>
);

export default App;